import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";

// const Notes = notes.map((not) => {
//   (id = not.key), (Title = not.title), (content = not.content);
// });

function Note(props) {
  function handleClick() {
    props.onDelete(props.id);
  }

  return (
    <div className="note">
      <h1>{props.title}</h1>
      <p>{props.content}</p>
      <button onClick={handleClick}>
        <DeleteIcon />
      </button>
    </div>
  );
}

export default Note;
